__webpack_require__.p = "/color-grading/";